import { validateAnchors } from './offset'
import { validateRepeat } from './repeat'
import { validateAvailability } from './availability'
import { validateEndRules } from './endRules'
import { validateTargeting } from './targeting'
import { validateCompoundAnchors } from './compound'

export const validateSchedule = (schedule, scheduleIndex, entityLookup) => ({
  ...validateAnchors(schedule, scheduleIndex),
  ...validateRepeat(schedule, scheduleIndex),
  ...validateAvailability(schedule, scheduleIndex, entityLookup),
  ...validateEndRules(schedule, scheduleIndex, entityLookup),
  ...validateTargeting(schedule, scheduleIndex),
  ...validateCompoundAnchors(schedule, scheduleIndex, entityLookup),
})

export const validateEngineSchedules = (schedules, entityLookup) => {
  const errors = {}
  if (!schedules?.length) {
    errors.schedules = 'At least one deployment schedule is required.'
    return errors
  }
  schedules.forEach((schedule, index) => {
    Object.assign(errors, validateSchedule(schedule, index, entityLookup))
  })
  return errors
}

export const hasValidationErrors = errors => Object.keys(errors || {}).length > 0

/** @deprecated */
export const validateRule = validateSchedule
